import React, { useEffect, useState } from "react";
import axios from "axios";
import "./reg.css";
import warningIcon from "./../../Constant/Icons/warning.svg";
import Incorrect from "./../../Constant/Icons/Incorrect.svg";
import correct from "./../../Constant/Icons/correct.svg";
import eyeIcon from "../../Constant/Icons/eye.svg";
import eyeSlashIcon from "../../Constant/Icons/eyehide.svg";
import AddUser from "../../Constant/Icons/adduser.svg";
import Header from "./Header";
import PopModal from "../../Constant/Custom/Models/PopModal";
import { serverUrl } from "../../Constant/Static/config";

function RegistrationForm() {
  const [formData, setFormData] = useState({
    name: { value: "", isValid: true },
    email: { value: "", isValid: true },
    mobile: { value: "", isValid: true },
    password: { value: "", isValid: true },
    confirm_password: { value: "", isValid: true },
    onetimepass: { value: "", isValid: true },
  });

  const regex = {
    name: /^[a-zA-Z][a-zA-Z\s@]{3,}$/,
    mobile: /^[6-9]\d{9}$/,
    email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
  };

  const [passwordCheck, setPasswordCheck] = useState({
    lengthCheck: { pattern: 10, isValid: false },
    numberCheck: { pattern: /.*[0-9].*/, isValid: false },
    lowercaseCheck: { pattern: /.*[a-z].*/, isValid: false },
    uppercaseCheck: { pattern: /.*[A-Z].*/, isValid: false },
    specialCharCheck: {
      pattern: /.*[!@#$%^&*()_+-=[\]{};':"\\|,.<>/?].*/,
      isValid: false,
    },
  });

  const [isSendingOTP, setIsSendingOTP] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [resendTimer, setResendTimer] = useState(200);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const [onConfirm, setOnConfirm] = useState(() => () => { });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const targetDate = new Date("2026-07-07T00:00:00");
  const [timeLeft, setTimeLeft] = useState(null);
  const [isExpired, setIsExpired] = useState(false);

  const isFormLocked = isOtpSent || isOtpVerified;

  const onRegister = () => {
    window.location.href = "/login";
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const setDefaultForm = (e) => {
    setFormData({
      name: { value: "", isValid: true },
      email: { value: "", isValid: true },
      mobile: { value: "", isValid: true },
      password: { value: "", isValid: true },
      confirm_password: { value: "", isValid: true },
      onetimepass: { value: "", isValid: true },
    });
    setPasswordCheck({
      lengthCheck: { pattern: 10, isValid: false },
      numberCheck: { pattern: /.*[0-9].*/, isValid: false },
      lowercaseCheck: { pattern: /.*[a-z].*/, isValid: false },
      uppercaseCheck: { pattern: /.*[A-Z].*/, isValid: false },
      specialCharCheck: {
        pattern: /.*[!@#$%^&*()_+-=[\]{};':"\\|,.<>/?].*/,
        isValid: false,
      },
    })
    setIsOtpSent(false);
    setIsOtpVerified(false);
  };

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const validateField = (name, value) => {
    let isValid = false;
    if (name === "name" && regex.name.test(value.trim().toUpperCase())) {
      isValid = true;
    }
    if (name === "email" && regex.email.test(value.trim())) {
      isValid = true;
      // console.log("Valid");
    }
    if (name === "mobile" && regex.mobile.test(value.trim())) {
      isValid = true;
      // console.log("Valid");
    }
    if (name === "confirm_password") {
      isValid = value.trim() === formData.password.value.trim();
    }
    if (name === "password") {
      const isValidLength = value.trim().length >= 7;
      const containsNumber = /\d/.test(value.trim());
      const containsLowercase = /[a-z]/.test(value.trim());
      const containsUppercase = /[A-Z]/.test(value.trim());
      const containsSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
        value.trim()
      );
      isValid =
        isValidLength &&
        containsNumber &&
        containsLowercase &&
        containsUppercase &&
        containsSpecialChar;

      if (formData.confirm_password.value.trim() && value.trim() !== formData.confirm_password.value.trim()) {

        setFormData((prevFormData) => ({
          ...prevFormData,
          ["confirm_password"]: { value: prevFormData.confirm_password.value, isValid: false },

        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          ["confirm_password"]: { value: prevFormData.confirm_password.value, isValid: true },

        }));
      }
    }
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let isValid = false;

    // if (name === 'name') {
    //     const trimmedValue = value.trim();
    //     const upperValue = value.toUpperCase();

    //     if (regex.name.test(trimmedValue.toUpperCase())) {
    //         isValid = true;
    //         // console.log('Valid');
    //     }

    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         [name]: { value: upperValue, isValid }
    //     }));
    //     return;
    // }

    if (name === "password") {
      const isValidLength = value.length >= 7;
      const containsNumber = /\d/.test(value.trim());
      const containsLowercase = /[a-z]/.test(value.trim());
      const containsUppercase = /[A-Z]/.test(value.trim());
      const containsSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
        value.trim()
      );

      setPasswordCheck({
        ...passwordCheck,
        lengthCheck: { ...passwordCheck.lengthCheck, isValid: isValidLength },
        numberCheck: { ...passwordCheck.numberCheck, isValid: containsNumber },
        lowercaseCheck: {
          ...passwordCheck.lowercaseCheck,
          isValid: containsLowercase,
        },
        uppercaseCheck: {
          ...passwordCheck.uppercaseCheck,
          isValid: containsUppercase,
        },
        specialCharCheck: {
          ...passwordCheck.specialCharCheck,
          isValid: containsSpecialChar,
        },
      });

      isValid =
        isValidLength &&
        containsNumber &&
        containsLowercase &&
        containsUppercase &&
        containsSpecialChar;
    } else {
      if (name === "name") {
        isValid = formData.name.isValid;
        // console.log("valid", isValid);
      }
      if (name === "email") {
        isValid = formData.email.isValid;
        // console.log("Valid");
      }
      if (name === "mobile") {
        isValid = formData.mobile.isValid;
        // console.log("Valid");
      }
      if (name === "confirm_password") {
        isValid = formData.confirm_password.isValid;
      }
      if (!isValid) {
        // console.log("not valid");

        isValid = validateField(name, value);
        // console.log("validation", isValid);

      }
    }
    if (name === "name") {
      // const trimmedValue = value.trim();
      const upperValue = value.toUpperCase();
      // isValid = formData.name.isValid;
      // console.log("valid", isValid);

      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: { value: upperValue, isValid },
      }));
      return;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: { value, isValid },
    }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    // console.log("onblur", name, " ", value);
    if (value.length) {
      const isValid = validateField(name, value);
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: { value, isValid },
      }));
    }
  }

  const handleSendOTP = async () => {
    const isFormValid = Object.values(formData).every((field) => field.isValid);
    let isDataValid = false;
    if (formData.name.value !== "" && formData.email.value !== "" && formData.mobile.value !== "" && formData.password.value !== "" && formData.confirm_password.value !== "") {
      isDataValid = true;
    }
    if (!isFormValid || !isDataValid) {
      // console.log("Form is not valid");
      return;
    }
    setIsSendingOTP(true);
    if (formData.mobile.value.length === 10) {
      // console.log(formData.mobile.value);
      try {
        // Send OTP via API call
        const response = await axios.post(`${serverUrl}/api/send-otp`, {
          mobile: formData.mobile.value.trim(),
          email: formData.email.value.trim(),
        });
        // console.log(response);
        if (response.status === 200) {
          setModalType({
            icon: "success",
            title: "Success",
            text: response.data.message,
          });
          openModal();
          setOnConfirm(() => closeModal);
        }
        setIsOtpSent(true);
        const interval = setInterval(() => {
          setResendTimer((prev) => {
            if (prev <= 0) {
              clearInterval(interval);
              setIsSendingOTP(false);
              setIsOtpSent(false);
              return 200;
            }
            return prev - 1;
          });
        }, 1000);
      } catch (error) {
        
        setModalType({
          icon: "error",
          title: "Error",
          text: error.response.data.message,
        });
        openModal();
        setOnConfirm(() => closeModal);
        setDefaultForm();
        console.error("Error sending OTP:", error);

      } finally {
        setIsSendingOTP(false);
      }
    }
  };

  const handleVerifyOtp = async () => {
    if (!formData.onetimepass.value) {
      setModalType({ icon: 'warning', title: 'Warning', text: 'Please Enter OTP' });
      openModal();
      setOnConfirm(() => closeModal);
      return;
    }
    try {
      const res = await axios.post(`${serverUrl}/api/verify-otp`, {
        mobile: formData.mobile.value.trim(),
        otp: formData.onetimepass.value.trim()
      });
      if (res.status === 200) {
        setIsOtpVerified(true);
        setModalType({ icon: 'success', title: 'Success', text: 'OTP Verified Successfully' });
        openModal();
        setOnConfirm(() => closeModal);
        // console.log(res.data);
      }
    } catch (error) {
      if (error.status === 400) {

        setModalType({ icon: 'error', title: 'Invalid', text: 'OTP Mismatch' });
        openModal();
        setOnConfirm(() => closeModal);
      }
      console.error("Error verifying OTP:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const btn = document.getElementById("sendOtpBtn")
    // console.log("otp buttton", btn.type);

    if (!isOtpVerified) {
      setModalType({ icon: 'warning', title: 'Info', text: 'Please verify OTP' });
      openModal();
      setOnConfirm(() => closeModal);
      return;
    }
    const dataToSend = {
      name: formData.name.value.trim(),
      email: formData.email.value.trim(),
      mobile: formData.mobile.value.trim(),
      password: formData.password.value.trim(),
    };

    try {
      const res = await axios.post(`${serverUrl}/api/register`, dataToSend);
      if (res.status === 200) {

        setModalType({ icon: 'success', title: 'Success', text: 'Registration successful!' });
        openModal();
        setOnConfirm(() => onRegister);
        // console.log(`Registration successful. Your application number is ${res.data.appnumber}`);
        // window.location.href = '/';
      }
        // console.log(res.data);
    } catch (err) {
      // Check if the error has a response and if it's a 400 status code
      if (err.response) {
        if (err.response.status === 400) {
          setModalType({ icon: 'warning', title: 'Warning', text: 'Applicant already registered.' });
          openModal();
          setOnConfirm(() => closeModal);
          setDefaultForm();
          // console.log("Error during registration: " + err.response.data.message);
        } else {
          // Handle other error statuses
          setModalType({ icon: 'error', title: 'Error', text: 'An error occurred. Please try again.' });
          openModal();
          setOnConfirm(() => closeModal);
          setDefaultForm();
          // console.log("Error during registration: " + err.response.data);
        }
      } else {
        // Handle network errors or other issues
        setModalType({ icon: 'error', title: 'Error', text: 'An error occurred. Please try again.' });
        openModal();
        setOnConfirm(() => closeModal);
        setDefaultForm();
        // console.log("Error during registration: " + err.message);
      }
    }
  };

  const handleCancel = async () => {
    window.location.reload();
  };

  useEffect(() => {
    const handleRightClick = (e) => {
      e.preventDefault();
      alert("Right-click is disabled!");
    };

    document.addEventListener("contextmenu", handleRightClick);
    const handleKeyPress = (e) => {
      // Disable F12, Ctrl+Shift+I, and Ctrl+Shift+J
      if (
        e.keyCode === 123 || // F12 key
        (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl + Shift + I
        (e.ctrlKey && e.shiftKey && e.keyCode === 74)
      ) {
        // Ctrl + Shift + J
        e.preventDefault();
        alert("Developer tools are disabled!");
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    const interval = setInterval(() => {
      const now = new Date();
      const timeDifference = targetDate - now;

      if (timeDifference <= 0) {
        setIsExpired(true);
        clearInterval(interval);
        return;
      }

      // Calculate time remaining
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => {
      clearInterval(interval); // Cleanup interval on unmount
      document.removeEventListener("contextmenu", handleRightClick); // Cleanup right-click event
      document.removeEventListener("keydown", handleKeyPress); // Cleanup keydown event
    };
  }, []);

  return (
    <div>
      <Header />
      {isExpired ? (<div className='text-danger' style={{ marging: '0', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '40px', fontWeight: '600', width: '100%', height: '90dvh' }}>Registration has been closed!</div>) : (
        <div>
          <form className='form-container' onSubmit={handleSubmit} >
            <div className='section-one'>
              <div style={{
                position: 'sticky',
                top: 0,
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '5%',
                '-webkit-sticky': 'top',
                'sticky': 'top',
                zIndex: 10,
                borderBottom: '1px solid #E2DFD2'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <h4 style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#1C274C'
                  }}>
                    <img src={AddUser} alt='wrong' width={25} height={25} />
                    &ensp; User Registration
                  </h4>
                  <p style={{ margin: '0 3%', fontWeight: '550' }}>Will be closed In <span className='text-danger'>{timeLeft ? `${timeLeft.days}d ${timeLeft.hours}h ${timeLeft.minutes}m ${timeLeft.seconds}s` : 'Calculating...'}</span></p>
                </div>

              </div>
              <div className='form-row'>
                <div className='label-container'>
                  <label>Applicant's Name</label>
                  <p className='label-tamil'>(விண்ணப்பதாரரின் பெயர்)</p>
                </div>
                <input
                  className={formData.name.isValid ? 'valid' : 'not-valid'}
                  type="text"
                  name="name"
                  value={formData.name.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='Enter Applicant Name'
                  disabled={isFormLocked}
                  required
                />
                <span>Name as of your 10th Certificate</span>
              </div>
              {!formData.name.isValid && (
                <div className='mobile-error'>
                  <img src={warningIcon} alt='wrong' width={20} height={20} />
                  <span>Enter a valid Name</span>
                </div>
              )}
              <div className='form-row'>
                <div className='label-container'>
                  <label>Email ID</label>
                  <p className='label-tamil'>(மின்னஞ்சல் முகவரி)</p>
                </div>
                <input
                  className={formData.email.isValid ? 'valid' : 'not-valid'}
                  type="email"
                  name="email"
                  value={formData.email.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='Enter Email ID'
                  disabled={isFormLocked}
                  required
                />
                <span>e.g., aravind82ss@gmail.com</span>
              </div>
              {!formData.email.isValid && (
                <div className='mobile-error'>
                  <img src={warningIcon} alt='wrong' width={20} height={20} />
                  <span>Enter a valid email ID</span>
                </div>
              )}
              <div className='form-row'>
                <div className='label-container'>
                  <label>Mobile Number</label>
                  <p className='label-tamil'>(கைப்பேசி எண்)</p>
                </div>
                <input
                  className={formData.mobile.isValid ? 'valid' : 'not-valid'}
                  type="text"
                  name="mobile"
                  value={formData.mobile.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='Enter Mobile Number'
                  disabled={isFormLocked}
                  required
                />
                <span>e.g., 9600394883</span>
              </div>
              {!formData.mobile.isValid && (
                <div className='mobile-error'>
                  <img src={warningIcon} alt='wrong' width={20} height={20} />
                  <span>Enter valid mobile number</span>
                </div>
              )}
              <div className='form-row'>
                <div className='label-container'>
                  <label>Password</label>
                  <p className='label-tamil'>(கடவுச்சொல்லை உள்ளிடுக)</p>
                </div>
                <input
                  className={formData.password.isValid ? 'valid' : 'not-valid'}
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='Enter Password'
                  disabled={isFormLocked}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={handlePasswordVisibility}
                  aria-label={showPassword ? 'Hide Password' : 'Show Password'}
                  style={{ position: "absolute", top: "27px" }}
                >
                  <img src={showPassword ? eyeSlashIcon : eyeIcon} alt="toggle password visibility" width={20} height={20} />
                </button>
              </div>
              {!formData.password.isValid && (
                <div className='password-error'>
                  <ul>
                    <li><img src={passwordCheck.lengthCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password length should be greater than or equal to 7.</li>
                    <li><img src={passwordCheck.uppercaseCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password should contain atleast one uppercase character.</li>
                    <li><img src={passwordCheck.lowercaseCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password should contain atleast one lowercase character.</li>
                    <li><img src={passwordCheck.specialCharCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password should contain atleast one special character.</li>
                    <li><img src={passwordCheck.numberCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password should contain atleast one number.</li>
                  </ul>
                </div>
              )}

              <div className="form-row">
                <div className="label-container">
                  <label>Confirm Password</label>
                  <p className="label-tamil">(கடவுச்சொல்லை உறுதிசெய்க)</p>
                </div>
                <input
                  className={
                    formData.confirm_password.isValid ? "valid" : "not-valid"
                  }
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  value={formData.confirm_password.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Confirm Password"
                  disabled={isFormLocked}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={handleConfirmPasswordVisibility}
                  aria-label={
                    showConfirmPassword ? "Hide Password" : "Show Password"
                  }
                  style={{ position: "absolute", top: "27px" }}
                >
                  <img
                    src={showConfirmPassword ? eyeSlashIcon : eyeIcon}
                    alt="toggle password visibility"
                    width={20}
                    height={20}
                  />
                </button>
              </div>
              {!formData.confirm_password.isValid && (
                <div className="password-error">
                  <ul>
                    <li>
                      <img src={Incorrect} alt="wrong" width={15} height={15} />
                      Password doesn't match
                    </li>
                  </ul>
                </div>
              )}
              <div className="sendOtp">
                <input
                  id="sendOtpBtn"
                  type="button"
                  style={(isSendingOTP || isOtpSent || isOtpVerified) ? { cursor: 'not-allowed', backgroundColor: '#808080' } : {}}
                  disabled={isSendingOTP || isOtpSent || isOtpVerified}
                  onClick={handleSendOTP}
                  value={isSendingOTP
                    ? "Sending..."
                    : isOtpSent
                      ? `Resend OTP in ${resendTimer}s`
                      : "Send OTP"}
                >

                </input>
                {/* <p>Resend OTP in {resendTimer} seconds</p> */}
              </div>
              {isOtpSent && (
                <div className="form-row">
                  <div className="label-container">
                    <label>Enter OTP</label>
                    <p className="label-tamil">(OTP யை உள்ளிடுக)</p>
                  </div>
                  <input
                    type="text"
                    name="onetimepass"
                    value={formData.onetimepass.value}
                    disabled={isOtpVerified}
                    onChange={handleChange}
                    placeholder="Enter OTP"
                    required
                  />
                  <div className="verifyOtp">
                    <button type="button" onClick={handleVerifyOtp} style={isOtpVerified ? { cursor: 'not-allowed', backgroundColor: '#808080' } : { cursor: 'pointer' }} disabled={isOtpVerified}>
                      Verify OTP
                    </button>
                  </div>
                </div>
              )}
              <div className="register">
                <input
                  type="submit"
                  style={!isOtpVerified ? { cursor: 'not-allowed', backgroundColor: '#808080' } : { cursor: 'pointer' }}
                  disabled={!isOtpVerified}
                  value={"Register"}
                />
              </div>
            </div>
          </form>
        </div>
      )}
      <div>
        <PopModal
          isOpen={isModalOpen}
          onConfirm={onConfirm}
          type={modalType}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
}

export default RegistrationForm;
